import { createFcmExperimentsContext } from 'src/app/shared/contexts/experiment';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmExperimentsContext: StarterDashboardPageFcmExperimentsContext,
	FcmExperimentsProvider: StarterDashboardPageFcmExperimentsContextProvider,
	useFcmExperiments: useStarterDashboardPageFcmExperiments,
	useAsyncFcmExperiments: useAsyncStarterDashboardPageFcmExperiments,
	prefetchFcmExperiments: prefetchStarterDashboardPageFcmExperiments,
} = createFcmExperimentsContext({
	name: 'StarterDashboardPageFcmExperimentsContext',
	dataProperty: 'pageFcmExperiments',
	configs: {
		// DO NOT ADD ANYTHING HERE - USE GQL INSTEAD
	},
	prefetch: true,
});

export type StarterDashboardPageFcmExperimentsState = ReturnType<typeof useAsyncStarterDashboardPageFcmExperiments>;
export type StarterDashboardPageFcmExperiments = LoadedStateData<StarterDashboardPageFcmExperimentsState>;
